/**
 * 应用初始化服务
 */
export const initializeApp = async (): Promise<void> => {
  // 可以在这里添加应用初始化逻辑
  console.log('收入管理系统初始化完成');
};
